import React from 'react';
import  './css/Accion.css';

export default class Accion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {}
  }

  render(){
    const {fontSize,backgroundColor, disabled, icono, ayuda, onClick} = this.props;
    return(
      <span
        className="material-icons Accion"
        style={{
          fontSize,
          backgroundColor,
          color: disabled ? "grey" : "black",
          cursor: disabled ? "not-allowed" : "pointer",
          display:'flex', justifyContent:'center', alignItems:'center'
        }}
        onClick={() => !disabled && onClick()}
        title={ayuda}
      > {icono} </span>
    )
  }
}

/*
import {Accion} from '../comun/Index';

<Accion
  icono=""
  ayuda=""
  backgroundColor="#"
  disabled={false}
  onClick={() => funcion()}
/>
*/
